import type { ISubmitAction, SubmitActionOptions } from '../../core';
import { SubmitAction } from '../../core';

import type { MSTeamsData } from './ms-teams-data';

export type TaskFetchActionOptions = SubmitActionOptions & {
  data: MSTeamsData<ITaskFetchData>;
};

export type TaskFetchDataValues = {
  [key: string]: any;
} & {
  /** type is special so we shouldn't allow overriding it */
  type?: never;
};

/**
 * @deprecated This type is deprecated. Please use {@link ITaskFetchSubmitActionData} instead. This will be removed in a future version of the SDK.
 */
export interface ITaskFetchAction extends ISubmitAction {
  /**
   * Initial data that input fields will be combined with. These are essentially ‘hidden’ properties.
   */
  data: MSTeamsData<ITaskFetchData>;
}

/**
 * @deprecated This class is deprecated. Please use {@link TaskFetchSubmitActionData} instead. This will be removed in a future version of the SDK.
 */
export class TaskFetchAction extends SubmitAction implements ITaskFetchAction {
  /**
   * Initial data that input fields will be combined with. These are essentially ‘hidden’ properties.
   */
  data: MSTeamsData<ITaskFetchData>;

  constructor(value?: TaskFetchDataValues, options: SubmitActionOptions = {}) {
    super(options);
    Object.assign(this, options);
    this.data = {
      ...value,
      msteams: {
        type: 'task/fetch',
      },
    };
  }

  static from(options: TaskFetchActionOptions): TaskFetchAction {
    return new TaskFetchAction(options.data, options);
  }

  withData(value: MSTeamsData<ITaskFetchData>): this {
    this.data = value;
    return this;
  }

  withValue(value: TaskFetchDataValues): this {
    super.withData({ ...this.data, ...value, msteams: { type: 'task/fetch' } });
    return this;
  }
}

/**
 * @deprecated This type is deprecated. Please use {@link ITaskFetchSubmitActionData} instead. This will be removed in a future version of the SDK.
 */
export interface ITaskFetchData {
  type: 'task/fetch';
}

/**
 * @deprecated This class is deprecated. Please use {@link TaskFetchSubmitActionData} instead. This will be removed in a future version of the SDK.
 */
export class TaskFetchData implements MSTeamsData<ITaskFetchData> {
  msteams = {
    type: 'task/fetch' as const,
  };

  constructor(data?: TaskFetchDataValues) {
    // omit the msteams property if it exists
    if (data) {
      const { msteams, ...rest } = data;
      Object.assign(this, rest);
    }
  }
}
